import React from "react";
import { skillsData } from "./SkillData";
import styled from "styled-components";
const Skill = () => {
  return (
    <SkillSection>
      <div className="skill-hero">
        <p className="heading">Skills</p>

        <p className="desc">
          <span>"</span>
          Talent you have naturally. Skill is only developed by hours and hours
          and hours of beating on your craft."
          <br /> -Will Smith
        </p>
      </div>
      <div className="skills">
        {skillsData.map((skill, index) => (
          <div className={`skill ${index % 2 === 1 ? `alternate-skill` : ``}`}>
            {" "}
            <img alt="skill" src={skill} />
          </div>
        ))}
      </div>
    </SkillSection>
  );
};
const SkillSection = styled.div`
  margin: 1rem;
  .skill-hero {
    text-align: center;

    .heading {
      font-size: 4rem;
      color: black;
      font-family: "Playfair Display", serif;
    }
    .desc {
      color: gray;
      font-size: 1.4rem;
      margin-bottom: 4rem;
      margin-top: 0;
      font-family: "Montserrat", sans-serif;
      span {
        font-size: 3rem;
      }
    }
  }
  .skills {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    .skill {
      margin: 1.2rem;
      animation: float infinite 2.8s ease-in-out;
      img {
        width: 8rem;
        height: 8rem;
      }
    }
    .alternate-skill {
      animation-delay: 0.2s;
    }
  }
  @keyframes float {
    0% {
      transform: translateY(-1rem);
    }
    50% {
      transform: translateY(0rem);
    }
    100% {
      transform: translateY(-1rem);
    }
  }
`;
export default Skill;
